var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '@app/utility/api.service';
import { I18nService } from '@app/core';
import { Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { UtilService } from '@app/utility/util.service';
import { UserService } from "@app/user.service";
import { AuthService } from "@app/auth.service";
import { SocketioService } from '@app/socketio.service';
import { timer } from 'rxjs/observable/timer';
var SinglegatewaywaitComponent = /** @class */ (function () {
    function SinglegatewaywaitComponent(router, activatedRoute, titleService, translateService, i18nService, Util, Api, user, Auth, socketService, idle, keepalive) {
        var _this = this;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.titleService = titleService;
        this.translateService = translateService;
        this.i18nService = i18nService;
        this.Util = Util;
        this.Api = Api;
        this.user = user;
        this.Auth = Auth;
        this.socketService = socketService;
        this.idle = idle;
        this.keepalive = keepalive;
        this.timeLeft = 3600;
        this.message = "";
        this._subscription = this.socketService.caller.subscribe(function (data) {
            if (data && data["referenceId"] == sessionStorage.getItem("referenceId")) {
                var thisTs = _this;
                var result = data["result"];
                if (result == 'Y') {
                    _this.Util.SuccessDialog("ท่านได้ทำการยืนยันตัวตนสำเร็จ");
                    thisTs.router.navigate(["/mainmenu/refundDeposits"]);
                }
                else {
                    _this.Util.ErrorDialog("ท่านทำการยืนยันตัวตนไม่สำเร็จ กรุณายืนยันตัวต้นใหม่อีกครั้ง");
                    thisTs.router.navigate(["/mainmenu/refundDeposits"]);
                }
            }
        });
    }
    SinglegatewaywaitComponent.prototype.ngOnInit = function () {
        this.socketService.setupSocketConnection();
        this.PortalUser = JSON.parse(localStorage.getItem("dpa_portal"));
        this.InvestigateAndAppealCondition(this.PortalUser.contactid);
        this.startTimer();
    };
    SinglegatewaywaitComponent.prototype.InvestigateAndAppealCondition = function (UID) {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs, drosWeb, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thisTs = this;
                        if (!!this.Util.IsNullOrUndefined(UID)) return [3 /*break*/, 2];
                        drosWeb = '';
                        return [4 /*yield*/, this.Api.postCustomApi("SingleGateway", "GetRefID", { UID: UID })];
                    case 1:
                        result = _a.sent();
                        if (!this.Util.IsNullOrUndefined(result) && result.length > 0) {
                            if (!this.Util.IsNullOrUndefined(result[0].authorizationUrl)) {
                                drosWeb = result[0].authorizationUrl;
                                sessionStorage.setItem("referenceId", result[0].referenceId);
                                window.open(drosWeb, "_blank");
                            }
                            else {
                                this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
                                thisTs.router.navigate(["/mainmenu/index"]);
                            }
                        }
                        else {
                            this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
                            thisTs.router.navigate(["/mainmenu/index"]);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
                        thisTs.router.navigate(["/mainmenu/index"]);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SinglegatewaywaitComponent.prototype.startTimer = function () {
        var _this = this;
        var source = timer(1000, 2000);
        var abc = source.subscribe(function (val) {
            if (val < 3600) {
                _this.message = _this.dhms(_this.timeLeft - val);
            }
            else {
                var thisTs = _this;
                _this.Util.WarningDialog("ท่านไม่ได้ทำรายการในเวลาที่กำหนด กรุณาเข้าระบบใหม่อีกครั้งหลังจากทำการยืนยันตัวตนเสร็จสิ้น");
                thisTs.router.navigate(["/mainmenu/index"]);
            }
        });
    };
    SinglegatewaywaitComponent.prototype.dhms = function (t) {
        var minutes, seconds;
        minutes = Math.floor(t / 60) % 60;
        t -= minutes * 60;
        seconds = t % 60;
        return [
            minutes + ' นาที',
            seconds + ' วินาที'
        ].join(' ');
    };
    SinglegatewaywaitComponent.prototype.ngOnDestroy = function () {
        //prevent memory leak when component destroyed
        this._subscription.unsubscribe();
    };
    return SinglegatewaywaitComponent;
}());
export { SinglegatewaywaitComponent };



// WEBPACK FOOTER //
// ./src/app/singlegatewaywait/singlegatewaywait.component.ts.pre-build-optimizer.js